export const GET_CHART_OF_ACCOUNTS_TEMPLATES_REQUEST =
  'chart-of-accounts/get-chart-of-accounts-templates-request';
export const GET_CHART_OF_ACCOUNTS_TEMPLATES_SUCCESS =
  'chart-of-accounts/get-chart-of-accounts-templates-success';
export const GET_CHART_OF_ACCOUNTS_TEMPLATES_FAILURE =
  'chart-of-accounts/get-chart-of-accounts-templates-failure';

export const FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_REQUEST =
  'chart-of-accounts/fetch-chart-of-accounts-by-country-request';
export const FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_SUCCESS =
  'chart-of-accounts/fetch-chart-of-accounts-by-country-success';
export const FETCH_CHART_OF_ACCOUNTS_BY_COUNTRY_FAILURE =
  'chart-of-accounts/fetch-chart-of-accounts-by-country-failure';

export const FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_REQUEST =
  'chart-of-accounts/fetch-chart-of-accounts-for-organisation-request';
export const FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_SUCCESS =
  'chart-of-accounts/fetch-chart-of-accounts-for-organisation-success';
export const FETCH_CHART_OF_ACCOUNTS_FOR_ORGANISATION_FAILURE =
  'chart-of-accounts/fetch-chart-of-accounts-for-organisation-failure';

export const SAVE_CHART_OF_ACCOUNTS_REQUEST =
  'chart-of-accounts/save-chart-of-accounts-request';
export const SAVE_CHART_OF_ACCOUNTS_SUCCESS =
  'chart-of-accounts/save-chart-of-accounts-success';
export const SAVE_CHART_OF_ACCOUNTS_FAILURE =
  'chart-of-accounts/save-chart-of-accounts-failure';

export const SAVE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST =
  'chart-of-accounts/save-chart-of-accounts-template-request';
export const SAVE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS =
  'chart-of-accounts/save-chart-of-accounts-template-success';
export const SAVE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE =
  'chart-of-accounts/save-chart-of-accounts-template-failure';

export const DELETE_CHART_OF_ACCOUNTS_TEMPLATE_REQUEST =
  'chart-of-accounts/delete-chart-of-accounts-template-request';
export const DELETE_CHART_OF_ACCOUNTS_TEMPLATE_SUCCESS =
  'chart-of-accounts/delete-chart-of-accounts-template-success';
export const DELETE_CHART_OF_ACCOUNTS_TEMPLATE_FAILURE =
  'chart-of-accounts/delete-chart-of-accounts-template-failure';

export const UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_REQUEST =
  'chart-of-accounts/update-chart-of-accounts-template-name-request';
export const UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_SUCCESS =
  'chart-of-accounts/update-chart-of-accounts-template-name-success';
export const UPDATE_CHART_OF_ACCOUNTS_TEMPLATE_NAME_FAILURE =
  'chart-of-accounts/update-chart-of-accounts-template-name-failure';

export const UPDATE_CHART_OF_ACCOUNTS_FOR_CONNECTION =
  'chart-of-accounts/update-chart-of-accounts-for-connection';

export const DELETE_CHART_OF_ACCOUNT_ROW_REQUEST =
  'chart-of-accounts/delete-chart-of-account-row-request';
export const DELETE_CHART_OF_ACCOUNT_ROW_SUCCESS =
  'chart-of-accounts/delete-chart-of-account-row-success';
export const DELETE_CHART_OF_ACCOUNT_ROW_FAILURE =
  'chart-of-accounts/delete-chart-of-account-row-failure';

export const CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST =
  'chart-of-accounts/create-chart-of-accounts-custom-row-request';
export const CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS =
  'chart-of-accounts/create-chart-of-accounts-custom-row-success';
export const CREATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE =
  'chart-of-accounts/create-chart-of-accounts-custom-row-failure';

export const UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_REQUEST =
  'chart-of-accounts/update-chart-of-accounts-custom-row-request';
export const UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_SUCCESS =
  'chart-of-accounts/update-chart-of-accounts-custom-row-success';
export const UPDATE_CHART_OF_ACCOUNTS_CUSTOM_ROW_FAILURE =
  'chart-of-accounts/update-chart-of-accounts-custom-row-failure';
